"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDayOfWeek = {
    0: 'sunday',
    1: 'monday',
    2: 'tuesday',
    3: 'wednesday',
    4: 'thursday',
    5: 'friday',
    6: 'saturday',
};
var MomentFormats;
(function (MomentFormats) {
    MomentFormats["TimeFormat"] = "HH:mm";
    MomentFormats["DateFormat"] = "YYYY-MM-DD";
    MomentFormats["DateTimeFormat"] = "YYYY-MM-DD HH:mm";
})(MomentFormats = exports.MomentFormats || (exports.MomentFormats = {}));
//# sourceMappingURL=dates.js.map